export default class Current {
  constructor() {
    this.marital_status = null;
  }
}
